<template>
  <section>
    <div class="left">
      <div v-if="entity.id">
        <DetailEntityInfo :entity="entity">
          <p v-translate>Poslední login: </p>
          <p>
            <translate>Počet odběratelů</translate>
            : {{ subscribersCount }}
          </p>
          <p>
            <translate>Počet zařízení</translate>
            : {{ devicesCount }}
          </p>
        </DetailEntityInfo>
      </div>
      <div v-else><h2 v-translate>Základní údaje</h2></div>
      <p class="profile_image_box">
        <label
            for="user_image"
            :class="['profile_image', {is_image: hasImage}, 'operator_logo']"
            :title="'Nahrát fotku' | translate">
          {{ operatorInitials }}<img :src="userImage" v-if="hasImage">
        </label>
        <input
            type="file"
            name="user_image"
            id="user_image"
            class="input_file"
            data-multiple-caption="{count} files selected"
            v-if="uploadReady"
            @change="onFileChange"
            ref="user_image"
            :disabled="!isEditable"
        />
        <label v-if="isEditable" for="user_image" class="add_profile_image">
          <span v-translate>Nahrát logo</span> (150×150px)
        </label>
        <a
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteImage"
            v-if="hasImage && isEditable"
            v-translate>Smazat
        </a>
      </p>
    </div>
    <div class="right">
      <div class="field">
        <text-input
            id="operatorname"
            :required="true"
            v-model="entity.name"
            ref="operatornameref"
            :disabled="!isEditable"
        >
          <translate class="translate">Název operátora</translate>
        </text-input>
      </div>
      <div class="field_left">
        <select-box
            id="operatorbrand"
            :options="allBrands"
            v-model="entity.id_brand"
            :required="true"
            ref="operatorbrandref"
            :disabled="!isEditable"
        >
          <translate class="translate">Brand</translate>
        </select-box>
        <select-box
            id="operatorcategory"
            :options="categoryOptions"
            v-model="entity.category"
            :required="true"
            ref="operatorcategoryref"
            :disabled="!isEditable"
        >
          <translate class="translate">Kategorie operátora</translate>
        </select-box>
      </div>
      <div class="field_right">
        <select-box
            id="operatorbusinessmodel"
            :options="allBusinessModels"
            v-model="entity.id_business_model"
            :required="true"
            ref="operatorbusinessmodelref"
            :disabled="!isEditable"
        >
          <translate class="translate">Business model</translate>
        </select-box>
      </div>
      <div class="field_left">
        <date-picker
            id="active_from"
            date-format="d. m. yy"
            attrKey="active_from"
            v-model="entity.active_from"
            @update-date="updateOperatorDate"
            :disabled="!isEditable"
        >
          <translate class="translate">Aktivní od</translate>
        </date-picker>
      </div>
      <div class="field_right">
        <date-picker
            id="active_to"
            attrKey="active_to"
            date-format="d. m. yy"
            v-model="entity.active_to"
            @update-date="updateOperatorDate"
            :disabled="!isEditable"
        >
          <translate class="translate">Aktivní do</translate>
        </date-picker>
      </div>
      <div class="field">
        <textarea-input
            id="note"
            name="note"
            rows="6"
            cols="50"
            v-model="entity.note"
            :disabled="!isEditable"
        >
          <translate class="translate">Poznámka</translate>
        </textarea-input>
      </div>
      <div class="field field_search">
        <multiselect-searchbox
            :searchFunction="searchTag"
            v-model="entity.tags"
            :disabled="!isEditable"
        ><translate>Štítky operátora</translate></multiselect-searchbox>
      </div>
    </div>
  </section>
</template>

<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo";

export default {
  name: "OperatorBasicInfo",
  components: {DetailEntityInfo},
  props: {
    entity: Object,
    isEditable: Boolean,
    allBrands: Array,
    allBusinessModels: Array,
    isOperatorMyOperator: Boolean,
    uploadReady: Boolean,
    selectedFile: File,
  },
  created(OperatorTagService){
    this.operatorTagService = OperatorTagService;
  },
  computed: {
    hasImage() {
      return this.selectedFile || (this.entity.logo !== null && this.entity.logo !== '')
    },
    userImage() {
      if (this.selectedFile) {
        return URL.createObjectURL(this.selectedFile)
      }
      return 'uploads/operator_logos/' + this.entity.logo
    },
    operatorInitials() {
      let initials = ''
      if (this.entity.name) {
        let words = this._.words(this.entity.name)
        initials = words[0].charAt(0)
        if (words.length > 1) {
          initials += words[1].charAt(0)
        }
      }
      return this._.toUpper(initials)
    },
    subscribersCount() {
      return this.entity.subscribers_count
    },
    devicesCount() {
      return this.entity.devices_count
    },
    categoryOptions() {
      return [
        {id: 'testing', text: this.$gettext('Testovací')},
        {id: 'production', text: this.$gettext('Produkční')},
      ]
    }
  },
  methods: {
    onFileChange(e) {
      //this.selectedFile = e.target.files[0]
      this.$emit('selected-file', e.target.files[0])
    },
    emitDeleteImage() {
      this.$emit('delete-image')
    },
    updateOperatorDate(dateInfo) {
      this.entity[dateInfo.attrKey] = dateInfo.date
    },
    searchTag(search, selectAll = false) {
      return this.operatorTagService.searchTagsByName({name_search: search, select_all: selectAll});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/settings/OperatorBasicInfo.vue